"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetworkConnector = exports.RPC_URLS = void 0;
const schemas_1 = require("@dcl/schemas");
const network_connector_1 = require("@web3-react/network-connector");
const configuration_1 = require("../configuration");
exports.RPC_URLS = Object.freeze(configuration_1.getRpcUrls(schemas_1.ProviderType.NETWORK));
class NetworkConnector extends network_connector_1.NetworkConnector {
    constructor(chainId) {
        super({ urls: exports.RPC_URLS, defaultChainId: chainId });
    }
}
exports.NetworkConnector = NetworkConnector;
//# sourceMappingURL=NetworkConnector.js.map